import { CURRENT_MEMBERS_ACTIVITIES_EVENT_ID, CURRENT_MEMBERS_ACTIVITIES_EVENT_NAME } from "../constants/memActConstant"


export const memActReducer = (state = {memActEventId: '', memActEventName: ''}, action) => {
    switch (action.type) {
        case CURRENT_MEMBERS_ACTIVITIES_EVENT_ID:
            return {
                ...state,
                memActEventId: action.payload
            }
        case CURRENT_MEMBERS_ACTIVITIES_EVENT_NAME:
            return {
                ...state,
                memActEventName: action.payload
            }

        default:
            return state
    }
}